import { useAtom } from 'jotai';
import { connectedWeb3AccountAtom } from '../web3Store.atoms';
import { EWalletType } from '../web3Store.enums';

export default function useConnectedWeb3Account(type: EWalletType) {
	return useAtom(connectedWeb3AccountAtom(type));
}
